import __ from './__';

export default (minLength: number) => (value: string) => {
  if ((value || '').length < minLength) {
    return `${__('Minimálny počet znakov je')} ${minLength}`;
  }
  return null;
};
